import layout from '@/views/layout/layout.vue'
const productList = r => require.ensure([], () => r(require('@/views/ywt/product/list.vue')), 'group-ywt-product')

const ywtProduct = [
  {
    path: '/ywt/product',
    name: 'ywt-product',
    component: layout,
    redirect: '/ywt/product/list',
    children: [
      {
        path: 'list',
        name: 'ywt-product-list',
        component: productList,
        meta: {
          displayName: '产品管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtProduct



// WEBPACK FOOTER //
// ./src/router/ywt/product.js